import properties from '../../modules/ajio-util/properties';
const getImagePath = (fileName: string): string => {
     return `${properties.getProperty('imageBaseUrl')}/static/img/${fileName}`;
};
async function isIncognitoMode(): Promise<boolean> {
  try {
    const { detectIncognito } = await import('detectincognitojs');
    let { isPrivate = false } = await detectIncognito();
    return isPrivate;
  } catch (error) {
    return true;
  }
}

const handleLikeCount = (num: number) => {
  if (num >= 1000 && num < 1000000) {
    return (num / 1000).toFixed(1) + 'k';
  }

  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'm';
  }

  return num.toString();
};

const getFileName =(url:string)=>{
  const fileName = url?.substring(url.lastIndexOf("/") + 1, url.length);
  return fileName;
}
export { getImagePath, isIncognitoMode, handleLikeCount, getFileName };
